module.exports = __webpack_public_path__ + "img/gear-wide.78b47c46.svg";